// src/EditProfilePage.js

import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Card, Layout, Menu, Select, DatePicker, InputNumber, Modal } from 'antd';
import {
  DashboardOutlined,
  EditOutlined,
  FileSearchOutlined,
} from '@ant-design/icons';
import { BrowserRouter as Router, Switch, Route, Link, useLocation  } from 'react-router-dom';
import Title from 'antd/lib/typography/Title';
import moment from 'moment';

import { useNavigate } from 'react-router';
import Sidebar from '../../Side_Bar/Admin_Side_Bar.js';

import axios from 'axios'; // Import axios library
const { Option } = Select;

const { Sider, Content } = Layout;

const EditContract = () =>{
  const location = useLocation();
  const { contract_id } = location.state || {};

  const mainUrl = "https://chatbot-summary-deployment-dot-fartech-yvqj.et.r.appspot.com";

  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(true); // Loading state
  const [form] = Form.useForm();
  const [tenureMonths, setTenureMonths] = useState(0);

  const [isChangeOk, setIsChangeOk] = useState(false);
  const [isChangeNotOk, setIsChangeNotOk] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Define an asynchronous function to fetch data
    const fetchData = async () => {
      try {
        const response                = await fetch(`${mainUrl}/getTable?tableName=Contract&contract_id=${contract_id}`);
        const CustomerPricingRateUrl  = await fetch(`${mainUrl}/getTable?tableName=Customer_Pricing&contract_id=${contract_id}`);
        const CompanyPricingRateUrl   = await fetch(`${mainUrl}/getTable?tableName=Company_Pricing&contract_id=${contract_id}`);

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const contract_data           = await response.json();
        const CustomerPricingData     = await CustomerPricingRateUrl.json();
        const CompanyPricingData      = await CompanyPricingRateUrl.json();


        const start_date = contract_data[0].start_date;
        const end_date   = contract_data[0].end_date;
        
        const formattedStartDate = moment(start_date)
        const formattedEndDate   = moment(end_date)

        setFormData({
          contract_id: contract_data[0].contract_id,
          name: contract_data[0].name,
          type: contract_data[0].type,
          description: contract_data[0].description,
          prepaid_amount: contract_data[0].prepaid_amount,
          monthly_message_quota: contract_data[0].monthly_message_quota,
          start_date: formattedStartDate,
          end_date: formattedEndDate,
          
          company_authentication: CompanyPricingData[0].authentication,
          company_service: CompanyPricingData[0].service,
          company_utility: CompanyPricingData[0].utility,
          company_unknown_type: CompanyPricingData[0].unknown_type,
          company_marketing: CompanyPricingData[0].marketing,
          company_session: CompanyPricingData[0].session,

          customer_authentication: CustomerPricingData[0].authentication,
          customer_service: CustomerPricingData[0].service,
          customer_utility: CustomerPricingData[0].utility,
          customer_unknown_type: CustomerPricingData[0].unknown_type,
          customer_marketing: CustomerPricingData[0].marketing,
          customer_session: CustomerPricingData[0].session
        });
        setTenureMonths(contract_data[0].monthly_duration)

        setLoading(false);
        // Process the data as needed
      } catch (error) {
        console.error('Error fetching table data:', error);
        setLoading(false);
        // Handle the error
      }
    };
  
    // Invoke the asynchronous function
    fetchData();
  }, []); // Include dependencies if needed
  
  const handleValuesChange = (_, allValues) => {
    const startDate = allValues.start_date;
    const endDate = allValues.end_date;

    if (startDate && endDate) {
      const startDateTime = new Date(startDate.format('YYYY-MM-DD'));
      const endDateTime = new Date(endDate.format('YYYY-MM-DD'));

      // Calculate the difference in months
      const monthsDiff = (endDateTime.getFullYear() - startDateTime.getFullYear()) * 12 +
        (endDateTime.getMonth() - startDateTime.getMonth());

      setTenureMonths(monthsDiff);
      console.log(tenureMonths)
    }
  };

  const onFinish = async (values) => {
    const updateData = {
      type: form.getFieldValue("type"),
      description: form.getFieldValue("description"),
      monthly_duration: tenureMonths,
      start_date: form.getFieldValue("start_date"),
      end_date: form.getFieldValue("end_date"),
      monthly_message_quota: parseFloat(form.getFieldValue("monthly_message_quota")),
      name: form.getFieldValue("name"),
      prepaid_amount: parseFloat(form.getFieldValue("prepaid_amount")),
      contract_id: form.getFieldValue("contract_id"),
    };
  
    const updatedCustomerPricing = {
      authentication_cost: form.getFieldValue("customer_authentication"), 
      marketing_cost: form.getFieldValue("customer_marketing"),
      service_cost: form.getFieldValue("customer_service"),
      utility_cost: form.getFieldValue("customer_utility"),
      unknown_cost: form.getFieldValue("customer_unknown_type"),
      session_cost: form.getFieldValue("customer_session"),
      contract_id: form.getFieldValue("contract_id"),
    };

    const updatedCompanyPricing = {
      authentication_cost: form.getFieldValue("company_authentication"), 
      marketing_cost: form.getFieldValue("company_marketing"),
      service_cost: form.getFieldValue("company_service"),
      utility_cost: form.getFieldValue("company_utility"),
      unknown_cost: form.getFieldValue("company_unknown_type"),
      session_cost: form.getFieldValue("company_session"),
      contract_id: form.getFieldValue("contract_id"),
    };

    // Make a PUT request to the /updateContract endpoint
    const updateDataAsync = async () => {
      try {
        const contractResponse = await axios.put(mainUrl + `/updateContract`, updateData);
        console.log('Updated contract:', contractResponse.data);
    
        const companyCostResponse = await axios.put(mainUrl + `/updateCompanyCost`, updatedCompanyPricing);
        console.log('Updated Company Cost:', companyCostResponse.data);
        
        // Wait for 1 second
        await new Promise(resolve => setTimeout(resolve, 1000));

        const customerCostResponse = await axios.put(mainUrl + `/updateCustomerCost`, updatedCustomerPricing);
        console.log('Updated Customer Cost:', customerCostResponse.data);

        setIsChangeOk(true);
      } catch (error) {
        console.error('Error updating:', error.response ? error.response.data : error.message);
        setIsChangeNotOk(true);
      }
    };
    
    updateDataAsync();
  };

  const handleModalOk = () => {
    // Handle the OK button in the modal
    // For example, navigate to another page or perform additional actions
    setIsChangeOk(false);
    navigate('/view_edit_contract');
  };

  const handleModalNotOk = () => {
    // Handle the OK button in the modal
    // For example, navigate to another page or perform additional actions
    setIsChangeNotOk(false);
    navigate('/view_edit_contract');
  };

  if (loading) {
    return <p>Loading...</p>;
  }

  const boxHeight = "50px";

  return (
    <Layout style={{ minHeight: '98vh' }}>
      <Sidebar location={location} />
          <Layout>
          <Title level={2} style={{marginTop: "0px", margin: "20px", fontWeight: "bold", textAlign: "left"}}>UPDATE SUBSCRIPTION DETAILS</Title>
          <div style={{ maxWidth: "100%", margin: '20px', textAlign: 'center', fontFamily: 'Helvetica, Arial, sans-serif' }}>
              <Form
                form={form}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 16 }}
                onFinish={onFinish}
                initialValues={formData}
                onValuesChange={handleValuesChange}
              >

                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                  <Form.Item name="name" 
                  rules={[{ required: true, message: 'Please enter the name' }]}
                  style={{ fontSize: '16px', flex: '1', marginRight: "35%" }}
                  >
                    <Input 
                    placeholder="Package Name"
                    style={{ height: boxHeight, width: "300%"}} />
                  </Form.Item>

                  <Form.Item 
                  name="type" 
                  rules={[{ required: true, message: 'Please enter the type' }]}
                  style={{ fontSize: '16px', flex: '1' }}
                  >
                    <Select placeholder="Package Type" style={{ height: boxHeight, width: "150%"}}>
                      <Option value="Basic">Basic</Option>
                      <Option value="Advance">Advance</Option>
                      <Option value="Comprehensive">Comprehensive</Option>
                      <Option value="Custom">Custom</Option>
                    </Select>
                  </Form.Item>

                </div>

                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                  
                </div>

                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                  <Form.Item 
                  name="description" 
                  rules={[{ required: true, message: 'Please enter the description' }]}
                  style={{ fontSize: '16px', flex: '1' }}
                  >
                    <Input 
                    placeholder="Description"
                    style={{ height: boxHeight, width: "150%"}} />
                  </Form.Item>
                </div>

                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                  <Form.Item 
                  name="monthly_message_quota" 
                  rules={[{ required: true, message: 'Please enter the message quota' }]}
                  style={{ fontSize: '16px', flex: '1' }}
                  >
                    <InputNumber 
                    placeholder="Message Quota"
                    style={{ height: boxHeight, width: "150%"}} />
                  </Form.Item>
                </div>

                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                  <Form.Item 
                  name="prepaid_amount" 
                  rules={[{ required: true, message: 'Please enter the prepaid amount' }]}
                  style={{ fontSize: '16px', flex: '1' }}
                  >
                    <InputNumber 
                    placeholder ="Prepaid Amount (RM)"
                    style={{ height: boxHeight, width: "150%"}} />
                  </Form.Item>
                </div>

                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                  <Form.Item
                    name="start_date"
                    rules={[{ required: true, message: 'Please select the tenure start date' }]}
                    style={{ fontSize: '16px', flex: '1' }}
                  >
                    <DatePicker 
                    placeholder="Tenure Start Date"
                    style={{ height: boxHeight, width: "140%", marginRight: "3%" }}/>
                  </Form.Item>

                  <Form.Item
                    name="end_date"
                    rules={[
                      { required: true, message: 'Please select the tenure end date' },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          const startDate = getFieldValue('start_date');

                          // Convert the dates to JavaScript Date objects
                          const startDateObject = new Date(startDate);
                          const endDateObject = new Date(value);

                          // Compare the dates
                          if (!value || startDateObject < endDateObject) {
                            // Calculate the difference in months
                            const monthsDiff = (endDateObject.getFullYear() - startDateObject.getFullYear()) * 12 +
                              (endDateObject.getMonth() - startDateObject.getMonth());

                            // Check the minimum and maximum difference
                            if (monthsDiff >= 6 && monthsDiff <= 36) {
                              return Promise.resolve();
                            } else {
                              return Promise.reject('Tenure must be between 6 months and 3 years');
                            }
                          }

                          return Promise.reject('End date must be after the start date');
                        },
                      }),
                    ]}
                    style={{ fontSize: '16px', flex: '1' }}
                  >
                    <DatePicker 
                    placeholder="Tenure End Date"
                    style={{ height: boxHeight, width: "140%", marginRight: "3%" }} />
                  </Form.Item>

                  <Form.Item label="Tenure (Months)" name="remainingTenureMonths">
                    <span>{tenureMonths}</span>
                  </Form.Item>
                </div>
                  
                
                <div style={{display: 'flex'}}>
                  <div style={{width: "50%", marginRight: "10%"}}>
                    <Title level={4} style={{marginTop: "1%"}}>Far Tech Cost</Title>
                    <Form.Item 
                      name="company_authentication" 
                      rules={[{ required: true, message: 'Please enter the description' }]}
                      style={{ fontSize: '16px', flex: '1' }}
                      label="Authentication"
                    >
                      <InputNumber 
                      placeholder="Authentication"
                      style={{ height: boxHeight, width: "150%"}} />
                    </Form.Item>

                    <Form.Item 
                      name="company_marketing" 
                      rules={[{ required: true, message: 'Please enter the description' }]}
                      style={{ fontSize: '16px', flex: '1' }}
                      label="Marketing"
                    >
                      <InputNumber 
                      placeholder="Marketing"
                      style={{ height: boxHeight, width: "150%"}} />
                    </Form.Item>

                    <Form.Item 
                      name="company_service" 
                      rules={[{ required: true, message: 'Please enter the description' }]}
                      style={{ fontSize: '16px', flex: '1' }}
                      label="Service"
                    >
                      <InputNumber 
                      placeholder="Service"
                      style={{ height: boxHeight, width: "150%"}} />
                    </Form.Item>

                    <Form.Item 
                      name="company_utility" 
                      rules={[{ required: true, message: 'Please enter the description' }]}
                      style={{ fontSize: '16px', flex: '1' }}
                      label="Utility"
                    >
                      <InputNumber 
                      placeholder="Utility"
                      style={{ height: boxHeight, width: "150%"}} />
                    </Form.Item>

                    <Form.Item 
                      name="company_unknown_type" 
                      rules={[{ required: true, message: 'Please enter the description' }]}
                      style={{ fontSize: '16px', flex: '1' }}
                      label="Unknown Type"
                    >
                      <InputNumber 
                      placeholder="Unknown Type"
                      style={{ height: boxHeight, width: "150%"}} />
                    </Form.Item>

                    <Form.Item 
                      name="company_session" 
                      rules={[{ required: true, message: 'Please enter the description' }]}
                      style={{ fontSize: '16px', flex: '1' }}
                      label="Session"
                    >
                      <InputNumber 
                      placeholder="Session"
                      style={{ height: boxHeight, width: "150%"}} />
                    </Form.Item>

                  </div>

                  <div style={{width: "50%"}}>
                    <Title level={4} style={{marginTop: "1%"}}>Company Cost</Title>
                    <Form.Item 
                      name="customer_authentication" 
                      rules={[{ required: true, message: 'Please enter the description' }]}
                      style={{ fontSize: '16px', flex: '1' }}
                      label="Authentication"
                    >
                      <InputNumber 
                      placeholder="Authentication"
                      style={{ height: boxHeight, width: "150%"}} />
                    </Form.Item>

                    <Form.Item 
                      name="customer_marketing" 
                      rules={[{ required: true, message: 'Please enter the description' }]}
                      style={{ fontSize: '16px', flex: '1' }}
                      label="Marketing"
                    >
                      <InputNumber 
                      placeholder="Marketing"
                      style={{ height: boxHeight, width: "150%"}} />
                    </Form.Item>

                    <Form.Item 
                      name="customer_service" 
                      rules={[{ required: true, message: 'Please enter the description' }]}
                      style={{ fontSize: '16px', flex: '1' }}
                      label="Service"
                    >
                      <InputNumber 
                      placeholder="Service"
                      style={{ height: boxHeight, width: "150%"}} />
                    </Form.Item>

                    <Form.Item 
                      name="customer_utility" 
                      rules={[{ required: true, message: 'Please enter the description' }]}
                      style={{ fontSize: '16px', flex: '1' }}
                      label="Utility"
                    >
                      <InputNumber 
                      placeholder="Utility"
                      style={{ height: boxHeight, width: "150%"}} />
                    </Form.Item>

                    <Form.Item 
                      name="customer_unknown_type" 
                      rules={[{ required: true, message: 'Please enter the description' }]}
                      style={{ fontSize: '16px', flex: '1' }}
                      label="Unknown Type"
                    >
                      <InputNumber 
                      placeholder="Unknown Type"
                      style={{ height: boxHeight, width: "150%"}} />
                    </Form.Item>

                    <Form.Item 
                      name="customer_session" 
                      rules={[{ required: true, message: 'Please enter the description' }]}
                      style={{ fontSize: '16px', flex: '1' }}
                      label="Session"
                    >
                      <InputNumber 
                      placeholder="Session"
                      style={{ height: boxHeight, width: "150%"}} />
                    </Form.Item>
                  </div>
                </div>

                
                
                <div style={{ marginLeft: '95%'}}>
                  <Form.Item>
                  <Button 
                  type="primary" htmlType="submit" 
                  style={{ height: boxHeight, background: "#00308F" }}>
                      UPDATE
                  </Button>
                  </Form.Item>
                </div>
              </Form>

            <Modal
              title="Subscription Details Edited"
              visible={isChangeOk}
              onOk={handleModalOk}
              okText="OK"
              closable={false}
              cancelButtonProps={{ style: { display: 'none' } }}
              centered
            >
              {/* Additional content in the modal */}
            </Modal>

            <Modal
              title="Error Editing Subscription"
              visible={isChangeNotOk}
              onOk={handleModalNotOk}
              okText="OK"
              closable={false}
              cancelButtonProps={{ style: { display: 'none' } }}
              centered
            >
              {/* Additional content in the modal */}
            </Modal>


          </div>
          </Layout>
          </Layout>
          
  );
};

export default EditContract;